import { Model, View } from '@lernetz/ts-lib';
import { data, route } from '@lernetz/ts-lib/src/Setup';

import template from './Materials.html';

abstract class Material extends Model {
    public constructor(public readonly description: string, public readonly icon: string, public readonly target: string, public readonly url: string) {
        super();
    }
}

export class Download extends Material {

    public constructor(dto) {
        super(dto.description, 'svg-Download', '_blank', route('download', { 'file_name': dto.file.file_name, 'locale': data('currentLocale') }).url());
    }
}

export class Link extends Material {

    public constructor(dto) {
        super(dto.description, 'svg-Link', dto.target || '_blank', dto.url || '#');
    }
}

export class NonMaterial extends Material {

    public constructor(dto) {
        super(dto.description, 'svg-Zusatzinfos', null, null);
    }
}

export class Materials extends Model {

    public readonly elements: Material;
    public readonly marginTop: string;
    public readonly marginBottom: string;

    public constructor(dto) {
        super({ elements: [], marginTop: '', marginBottom: '', ...dto });
    }
}

export class MaterialsView extends View<Materials> {

    public constructor() {
        super({ template });
    }
}
